export const setIsIndexLoading = isIndexLoading => ({
  setState
}) => {
  setState({
    isIndexLoading
  });
};